module.exports = __webpack_public_path__ + "static/media/gallery1.c8801773.jpg";